import { Component, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from "@angular/material/dialog";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-booking-outcome",
  templateUrl: "./booking-outcome.component.html",
  styleUrls: ["./booking-outcome.component.css"],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    TranslatePipe
  ]
})
export class BookingOutcomeComponent {
  dialogRef = inject<MatDialogRef<BookingOutcomeComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  mode = "CONFIRM";
  success = false;
  message = "";

  constructor() {
    const data = this.data;

    this.success = data.success;
    this.message = data.message;
    if (data.mode) {
      this.mode = data.mode;
    }
  }

  onRetryClick() {
    this.dialogRef.close({ retry: true });
  }
}
